import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import Chat from "src/components/panel/chat/Chat";

const ChatView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("chat_title_view")}</title>
      </Helmet>
      <Sidebar>
         {/* <Breadcrumb title={t("chat_title")} 
        subtitle={t("chat_subtitle")}/>  */}
        <Chat/>
      </Sidebar>
    </>
  );
};

export default ChatView;